import { render, staticRenderFns } from "./SelectableTags.vue?vue&type=template&id=68c14808&"
import script from "./SelectableTags.vue?vue&type=script&lang=ts&"
export * from "./SelectableTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports